module.exports = __webpack_public_path__ + "static/media/Loughton Alcove.07e97bc6.jpg";